<template>
  <li class="item">
    <div class="form-group form checkox-input item-name">
      <input
        :id="'result-' + itemID"
        type="checkbox"
        autocomplete="off"
        v-model="itemsSelected"
        :value="result"
        v-on:change="selectHandler()"
      />
      <label :for="'result-' + itemID">{{ result.SupplierName }}</label>
    </div>
    <div class="item-wrapper">
      <div class="item-heading">
        <div class="item-name">
          <button
            class="product-item-title-as-button"
            v-on:click="getSingleSupplierDetail(result.SupplierId)"
          >
            <h4 v-html="result.SupplierName"></h4>
          </button>
        </div>
        <div class="favorite-wrapper">
          <div class="favorite-container">
            <button
              class="favorite-button js-favorite-button hide-mobile"
              :class="isFavorite ? 'favorited' : 'not-favorited'"
              v-on:click="setMySupplier(result.SupplierId)"
              tabindex="0"
            ></button>
            <div v-if="!isFavorite" class="favorite-tooltip">
              Select as My Supplier
            </div>
            <div v-if="isFavorite" class="favorite-tooltip">My Supplier</div>
          </div>
        </div>
        <span
          class="favorite-button hide-desktop"
          :class="isFavorite ? 'favorited' : 'not-favorited'"
        >
        </span>
      </div>

      <div class="item-rating-container">
        <div class="item-rating" v-if="result.NAPStarRating == 1">
          <span class="icon icon-star"></span>
          <span class="icon icon-star-empty"></span>
          <span class="icon icon-star-empty"></span>
        </div>
        <div class="item-rating" v-if="result.NAPStarRating == 2">
          <span class="icon icon-star"></span>
          <span class="icon icon-star"></span>
          <span class="icon icon-star-empty"></span>
        </div>
        <div class="item-rating" v-if="result.NAPStarRating == 3">
          <span class="icon icon-star"></span>
          <span class="icon icon-star"></span>
          <span class="icon icon-star"></span>
        </div>
        <div class="item-rating" v-if="result.NAPStarRating == 'DP'">
          DP
        </div>
      </div>
      <div class="item-details-container" tabindex="0">
        <div class="item-details" v-html="result.ProgramProducts"></div>
        <div
          v-if="result.LongProgramProducts != null"
          class="item-details-tooltip"
          v-html="result.LongProgramProducts"
        ></div>
      </div>
      <button
        class="unstyled-button"
        v-on:click="getSingleSupplierDetail(result.SupplierId)"
      >
        View
      </button>
    </div>
  </li>
</template>

<script>
import DateFormatService from "../../common/date-format.service";
import FavoriteService from "../../../services/favorite.service";

export default {
  props: {
    result: {
      type: Object,
      default: () => {},
    },
    selectedproducts: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isFavorite: false,
    itemID: null,
    listActionsStuck: false,
    itemsSelected: [],
    itemValue: "",
  }),
  watch: {
    showfilters: function(newVal) {
      this.showfilters = newVal;

      let body = document.getElementsByTagName("BODY")[0];

      if (newVal === true) {
        body.classList.add("collapse-shown");
        body.classList.remove("collapse-hide");
      } else {
        body.classList.add("collapse-hide");
        body.classList.remove("collapse-shown");
      }
    },
    selectedproducts: {
      handler(newVal) {
        this.itemsSelected = newVal;
      },
      deep: true,
    },
  },
  mounted() {
    this.itemID = this._uid;
    this.isFavorite = this.result.IsFavorite;

    this.itemsSelected = this.selectedproducts;
    this.stickListActions();

    $(window).on("scroll", (e) => {
      this.stickListActions();
    });
  },
  updated() {
    this.isFavorite = this.result.IsFavorite;
  },
  methods: {
    unselectSelectAll() {
      this.$emit("unselectselectall");
    },
    selectSingle() {
      this.$emit("selectsingleproduct", this.result);
    },
    selectHandler() {
      this.unselectSelectAll();
      this.selectSingle();
    },
    formatDate: function(date) {
      return DateFormatService.customFormatter(date, "full-slash");
    },
    getSingleSupplierDetail: function(supplierId) {
      const cookieName = "selectedProducts";
      document.cookie = cookieName + "=" + supplierId + ";path=/";
      window.location.href = `/members/products/detail/${supplierId}`;
    },
    setMySupplier(supplierId) {
      FavoriteService.toggleMySupplier(supplierId).then((response) => {
        if (response.ok) {
          this.isFavorite = !this.isFavorite;
          this.result.IsFavorite = this.isFavorite;
        }
      });
    },
    stickListActions() {
      let $stickyElem = $(".js-list-actions");
      let $stickyParent = $(".js-products-list");
      let parentOffset = Math.round($stickyParent.offset().top);
      let parentHeight = $stickyParent.outerHeight();
      let parentWidth = $stickyParent.width();
      let stickyHeight = $stickyElem.outerHeight();
      let viewHeight = $(window).height();

      $stickyElem.width(parentWidth);

      let offset =
        parentOffset + parentHeight + stickyHeight / 2 - $(window).scrollTop();

      if (offset <= viewHeight && !this.listActionsStuck) {
        this.listActionsStuck = true;
        $stickyElem.addClass("static");
      }
      if (offset > viewHeight && this.listActionsStuck) {
        this.listActionsStuck = false;
        $stickyElem.removeClass("static");
      }
    },
  },
};
</script>
